bam-news-detail {
  bam-contact-teaser {
    padding: 0 !important;
    margin-bottom: 2rem !important;

    bal-card.bam-contact-teaser__card:not([app-type=lead]) {
      flex-direction: column !important;
      box-shadow: none !important;
      min-height: unset !important;

      .bam-contact-teaser__image-container {
        padding: 0 0 0.75rem 0 !important;
      }

      .bam-contact-teaser__image-wrapper {
        width: 80px !important;
      }

      .bam-contact-teaser__details-container {
        padding: 0 0 0.5rem 0 !important;
      }

      .bam-contact-teaser__role {
        p {
          font-size: 0.75rem !important;
          line-height: 1rem !important;
        }
      }
    }
  }

  bam-blog-teaser {

    bam-blog-teaser-item {
      .bam-blog-teaser__item-box {
        margin: 0 !important;
        height: 100% !important;
      }

      .bal-card-content {
        display: flex;
        flex-direction: column;
        height: 100% !important;
      }

      bal-tag {
        width: max-content !important;
      }

      bal-button.mt-x-small {
        margin-top: auto !important;
      }
    }

    .bam-blog-teaser__header {
      margin-bottom: 0 !important;
    }
  }
  bam-text-and-image {
      .pb-6 {
        padding-bottom: 0.5rem !important;
      }

  }
}
